import { DeviceAttestBase as ReactNativeDeviceAttest } from './DeviceAttestBase'
export default ReactNativeDeviceAttest
